import { useEffect, useState } from 'react';
import { requireSupabase } from '@/lib/supabase';
import { formatDate } from '@/lib/format';

interface AuditLog {
  id: string;
  userName: string;
  action: string;
  targetType: string;
  targetId: string;
  details: string;
  createdAt: string;
}

export default function AdminActivity() {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    async function load() {
      try {
        const supabase = requireSupabase();
        const { data } = await supabase
          .from('audit_logs')
          .select('*')
          .order('created_at', { ascending: false })
          .limit(100);
        if (alive) setLogs((data as any[]) ?? []);
      } catch {}
      if (alive) setLoading(false);
    }
    load();
    return () => { alive = false; };
  }, []);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl md:text-2xl font-bold text-surface-900">Activity Log</h1>
        <p className="text-sm text-surface-500 mt-1">Track all admin actions across the store.</p>
      </div>

      <div className="bg-white rounded-xl border border-surface-200 overflow-hidden">
        {loading ? (
          <div className="flex items-center justify-center py-12"><i className="ri-loader-4-line animate-spin text-surface-300 text-xl" /></div>
        ) : logs.length === 0 ? (
          <div className="text-center py-12 text-sm text-surface-400">No activity recorded yet.</div>
        ) : (
          <div className="divide-y divide-surface-100">
            {logs.map((log) => (
              <div key={log.id} className="flex items-start gap-3 px-5 py-3.5">
                <div className="w-8 h-8 rounded-full bg-brand-100 flex items-center justify-center text-brand-600 text-xs font-bold shrink-0"><i className="ri-edit-2-line" /></div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-surface-900"><span className="font-semibold">{log.userName}</span> {log.action} <span className="font-medium">{log.targetType}</span></p>
                  {log.details && <p className="text-xs text-surface-400 mt-0.5">{log.details}</p>}
                  <p className="text-[10px] text-surface-400 mt-1">{formatDate(log.createdAt)}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
